import { useState } from 'react'
import { DateRangePicker } from 'react-date-range'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'

import { useTranslation } from 'react-i18next'
import { IconButton } from '@mui/material'
import dayjs from 'dayjs'

interface Props {
  dateValue?: {
    startDate: Date | undefined
    endDate: Date | undefined
  }
  onDateChange: (value: { startDate: string; endDate: string }) => void
  onCloseDateRangeHandler?: () => void
  unUseDefaultClass?: boolean
}

const DateRangePickerComponent = ({
  dateValue,
  onDateChange,
  onCloseDateRangeHandler,
  unUseDefaultClass,
}: Props) => {
  const currentDate = new Date()
  const { t } = useTranslation('translation')
  const [value, setValue] = useState(() => {
    return {
      startDate: dateValue?.startDate || currentDate,
      endDate: dateValue?.endDate || currentDate,
      key: 'selection',
    }
  })

  const handleChange = (item: any) => {
    setValue({
      startDate: item.selection.startDate,
      endDate: item.selection.endDate,
      key: 'selection',
    })
  }

  const handleConfirmSelection = () => {
    onDateChange({
      startDate: dayjs(value.startDate).format('YYYY-MM-DD'),
      endDate: dayjs(value.endDate).format('YYYY-MM-DD'),
    })
    onCloseDateRangeHandler()
  }

  return (
    <div className={unUseDefaultClass ? '' : 'cstm-date-wraper'}>
      <div className="d-flex align-items-center mb-3">
        <span className="mr-auto pl-3">{t('Custom Date Range')}</span>
        <IconButton color="success" onClick={handleConfirmSelection}>
          <CheckIcon />
        </IconButton>
        <IconButton color="error" onClick={onCloseDateRangeHandler}>
          <CloseIcon />
        </IconButton>
      </div>
      <DateRangePicker
        onChange={handleChange}
        months={2}
        ranges={[value]}
        direction="horizontal"
        maxDate={currentDate}
      />
    </div>
  )
}

export default DateRangePickerComponent
